import {
  Box,
  Button,
  CircularProgress,
  Grid,
  Paper,
  Typography,
} from "@mui/material";
import { makeStyles } from "@mui/styles";
import { Form, Formik } from "formik";
import React, { useState } from "react";
import formInitialValues from "../gene20FormModel/formInitialValues";
import FormWrapper from "../../../layouts/layoutContainers/AuthContainers/formWrapper";
import gene20FormModel from "../gene20FormModel/gene20FormModel";
import validationSchema from "../gene20FormModel/validationSchema";

import { LoginHeader, StepperHeader } from "./components/headers";
import PaymentDetails from "./sessions/confirmInfoData";
import PersonalInfo from "./sessions/personalDetailsForm";
import RegistrationSuccess from "./sessions/registrationSuccess";
import profileImg from "../../../Assets/Images/user.svg";
import { ProfileInfo } from "./sessions";
const useStyles = makeStyles((theme) => ({
  root: {
    height: "100vh",
  },
  authsession: {
    height: "100vh",
  },
  submitButton: {
    width: "25vw",
    position: "relative",
    bottom: "0px",
  },
  formFields: {
    position: "fixed",
    alignItems: "center",
    alignContent: "center",
    flexGrow: 0,
    padding: "10px",
    backgroundColor: "#00000077",
  },
}));
const steps = [
  "personal info",
  "complete your profile Info",
  "confirm your registration",
];
const { formId, formField } = gene20FormModel;

function Header(params) {
  return (
    <Box>
      <Typography variant="h4">sign up</Typography>
    </Box>
  );
}

export default function SignUp() {
  const classes = useStyles();
  const [activeStep, setActiveStep] = useState(0);
  const [profilePic, setProfilePic] = useState(profileImg);

  const currentValidationSchema = validationSchema[activeStep];
  const isLastStep = activeStep === steps.length - 1;
  const fileSelectedHandler = (e) => {
    const [file] = e.target.files;
    const fileResult = URL.createObjectURL(file);
    setProfilePic(fileResult);
  };
  function _sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  async function _submitForm(values, actions) {
    await _sleep(1000);
    alert(JSON.stringify(values, null, 2));
    actions.setSubmitting(false);

    setActiveStep(activeStep + 1);
  }

  function _handleSubmit(values, actions) {
    if (isLastStep) {
      _submitForm(values, actions);
    } else {
      setActiveStep(activeStep + 1);
      actions.setTouched({});
      actions.setSubmitting(false);
    }
  }

  function _handleBack() {
    setActiveStep(activeStep - 1);
  }
  function _renderStepContent(step) {
    switch (step) {
      case 0:
        return <PersonalInfo formField={formField} />;
      case 1:
        return (
          <ProfileInfo
            setProfilePic={setProfilePic}
            profilePic={profilePic}
            formField={formField}
            fileSelectedHandler={fileSelectedHandler}
          />
        );
      case 2:
        // cut off
        // return <PortfolioInfo formField={formField} />;
        return (
          <PaymentDetails
          setProfilePic={setProfilePic}
          profilePic={profilePic}
          formField={formField}
        /> 
        );
      default:
        return <div>Not Found</div>;
    }
  }
  return (
    <FormWrapper>
      <Grid
        container
        sx={{ width: "100%", height: "100%", padding: "0vh 2vw" }}
      >
        <Grid
          item
          xs={12}
          align="center"
          // height="30vh"
          sx={{
            backgroundImage: `linear-gradient(44deg , #00000077 , #0909ff44)`,
            // margin: "auto 2vh",
            padding: "0vh 0vh",
            borderRadius: "0px 0px 20px 20px",
            position: "relative",
          }}
        >
          <LoginHeader />
          <Box
            sx={{
              backgroundImage: `linear-gradient(44deg , #00000077 , #0909ff44)`,
              // margin: "1vh",
              padding: "0vh 0vh",
              borderRadius: "0px 0px 20px 20px",
            }}
          >
            <StepperHeader
              steps={steps}
              activeStep={activeStep}
              setActiveStep={setActiveStep}
            />
          </Box>
        </Grid>
        <Grid item xs={12} className={classes.authsession}>
          {activeStep === steps.length ? (
            <RegistrationSuccess />
          ) : (
            <Formik
              initialValues={formInitialValues}
              validationSchema={currentValidationSchema}
              onSubmit={_handleSubmit}
            >
              {({ isSubmitting }) => (
                <Form id={formId}>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    align="right"
                    sx={{ margin: "5vh", position: "relative" }}
                  >
                    {_renderStepContent(activeStep)}
                  </Grid>
                  <Grid xs={12} sx={{ padding: "5vh 0vh", margin: "5vh 0vh" }}>
                    {activeStep !== 0 && (
                      <Button
                        className={classes.submitButton}
                        variant="outlined"
                        onClick={_handleBack}
                      >
                        Back
                      </Button>
                    )}

                    <Button
                      className={classes.submitButton}
                      disabled={isSubmitting}
                      type="submit"
                      variant="contained"
                      color="primary"
                    >
                      {isLastStep ? "Submit" : "Next"}
                    </Button>
                    {isSubmitting && <CircularProgress size={24} />}
                  </Grid>
                </Form>
              )}
            </Formik>
          )}
        </Grid>
      </Grid>
    </FormWrapper>
  );
}
